var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62408 10.4531C11.2781 11.5674 14.0457 10.9248 14.8056 9.01769C15.5655 7.11061 14.03 4.66126 11.3759 3.54692C8.72185 2.43258 5.95428 3.07523 5.19438 4.98231C4.43448 6.88939 5.97001 9.33874 8.62408 10.4531Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4549 12.3289C13.7507 13.2599 13.5087 15.8821 14.9143 18.1857C16.3199 20.4893 18.8409 21.602 20.5451 20.6711C22.2493 19.7401 22.4913 17.1179 21.0857 14.8143C19.6801 12.5107 17.1591 11.398 15.4549 12.3289Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9134 16.2491C12.4224 18.0539 10.6352 20.077 7.92158 20.7678C5.20798 21.4587 2.59556 20.5556 2.08658 18.7509C1.5776 16.9461 3.36481 14.923 6.07842 14.2322C8.79202 13.5413 11.4044 14.4444 11.9134 16.2491Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeds);
export default __webpack_public_path__ + "static/media/seeds.f122b71659410f205b6e91a0c3cb2d24.svg";
export { ForwardRef as ReactComponent };